import { SharedConfig } from '../../shared/shared.config'
import { SET_APP_ID, SET_SHARED_CONFIG } from './config.actions'
import { PayloadedAction } from '../../shared/types'
import { getAppId } from '../../shared/utils/cookies'

export interface ConfigState {
  sharedConfig: SharedConfig
  appId: string
}

export const initialState: ConfigState = {
  sharedConfig: null,
  appId: getAppId(),
}

export function reducer(
  state: ConfigState | undefined = initialState,
  action: PayloadedAction
): ConfigState {
  switch (action.type) {
    case SET_SHARED_CONFIG:
      return {
        ...state,
        sharedConfig: action.payload,
      }
    case SET_APP_ID:
      return {
        ...state,
        appId: action.payload?.toUpperCase() ?? getAppId(),
      }
    default:
      return state
  }
}
